export default __webpack_public_path__ + "static/media/logo_biru_2.59b6a409.png";